__turbopack_context__.v({
  "buttonBox": "styles-module-scss-module__BQDaFa__buttonBox",
  "icon": "styles-module-scss-module__BQDaFa__icon",
  "loading": "styles-module-scss-module__BQDaFa__loading",
  "root": "styles-module-scss-module__BQDaFa__root",
  "text": "styles-module-scss-module__BQDaFa__text",
});
